import R from "../../../R";

export function ProfileIcon(props: React.SVGProps<SVGSVGElement>) {
  const width = props.width || 26;
  const height = props.height || 26;

  const color = props.color || R.colors.deepBlue;
  return (
    <svg width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.5998 21.8V20.9998C6.5998 18.3488 8.74884 16.2 11.3998 16.2H14.5998C17.2508 16.2 19.3998 18.3488 19.3998 20.9998V21.8M12.9998 6.59999C11.2325 6.59999 9.7998 8.03268 9.7998 9.79999C9.7998 11.5673 11.2325 13 12.9998 13C14.7671 13 16.1998 11.5673 16.1998 9.79999C16.1998 8.03268 14.7671 6.59999 12.9998 6.59999ZM12.9998 24.2C6.81422 24.2 1.7998 19.1856 1.7998 13C1.7998 6.8144 6.81422 1.79999 12.9998 1.79999C19.1854 1.79999 24.1998 6.8144 24.1998 13C24.1998 19.1856 19.1854 24.2 12.9998 24.2Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
